import React from 'react';
import { useIntl } from 'react-intl';
import LinkAndAnchor from '../LinkAndAnchor';
import getMarketBreadcrumbs from '../Market/getBreadcrumbs';
import messages from '../../lib/messages.json';

const BreadCrumbs = ({
  marketName, marketId,
}) => {
  const intl = useIntl();

  return [
    ...getMarketBreadcrumbs({ marketName, marketId }),
    <LinkAndAnchor
      route="market-brands"
      params={{ marketId }}
    >
      {intl.formatMessage(messages.brands)}
    </LinkAndAnchor>,
  ];
};

export default BreadCrumbs;
